import { createContext, useContext } from 'react';
import type { usersApi } from '@services';

export type EmailVerificationStatus = usersApi.EmailVerificationStatus;

export interface EmailVerificationGate {
  /** `undefined` until the status is known (or when there is none to read). */
  verified: boolean | undefined;
  isLoading: boolean;
  /** Opens the verification dialog. */
  requestVerification: () => void;
}

export const EmailVerificationGateContext = createContext<EmailVerificationGate | null>(null);

export function useEmailVerificationGate(): EmailVerificationGate {
  const gate = useContext(EmailVerificationGateContext);
  if (!gate) throw new Error('useEmailVerificationGate must be used inside EmailVerificationProvider');
  return gate;
}
